@for (message of messages(); track message.id) {
  <div
    class="message-ui"
    [class.info]="message.level === EMessageLevel.INFO"
    [class.error]="message.level === EMessageLevel.ERROR"
    [class.warning]="message.level === EMessageLevel.WARNING"
    animate.enter="expand-down"
    animate.leave="collapse-up"
  >
    @if (message.durationMs > 0) {
      <button
        class="close-btn"
        matIconButton
        aria-label="Close"
        (click)="removeMessage(message.id)"
        libClickStopPropagation
        onclick="console.log('native click')"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    @for (messageLine of message.message; track $index) {
      <p>{{ messageLine }}</p>
    }
    @if (message.action) {
      <button
        class="action-btn"
        matButton="outlined"
        color="primary"
        (click)="onActionClick(message)"
        libClickStopPropagation
      >
        {{ message.action.label }}
      </button>
    }
  </div>
}
